import { render, staticRenderFns } from "./alreadySentPrivateManuscript.vue?vue&type=template&id=6e3c9e70&scoped=true&"
import script from "./alreadySentPrivateManuscript.vue?vue&type=script&lang=js&"
export * from "./alreadySentPrivateManuscript.vue?vue&type=script&lang=js&"
import style0 from "./alreadySentPrivateManuscript.vue?vue&type=style&index=0&id=6e3c9e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c9e70",
  null
  
)

export default component.exports